import React from "react";
import CustomButton from "../../../../components/controls/CustomButton";
import CustomLabel from "../../../../components/controls/CustomLabel";
import useTitanApp from "../../../../hooks/useTitanApp";
import LoadingComponentNMSPatient from "../../../../components/LoadingComponentNMS/LoadingComponentNMSPatient";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { countryNames } from "../../../../utils/countries";
import PreBookingCountry from "./PreBookingCountry";
import PreBookingVaccine from "./PreBookingVaccine";

export default function PrivateServicePreBooking({ transcript }) {
  const { nmsServiceState } = useTitanApp();
  const { isNmsLoading, responseDTOStagesData, service } =
    nmsServiceState || {};
  const stage = service?.stages[0];
  const serviceName = service?.serviceName;
  const getValueOrPlaceholder = (value) => {
    return value ?? "-";
  };
  const processedData = responseDTOStagesData.reduce((acc, item) => {
    acc[item.name] = item.value;
    return acc;
  }, {});
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));
  const checkCountryExists = (sectionTitle) => {
    return countryNames.some(
      (country) => country?.name?.toLowerCase() === sectionTitle?.toLowerCase()
    );
  };

  return isNmsLoading ? (
    <LoadingComponentNMSPatient />
  ) : (
    <div className="content-div patient-info-container private-service-activity">
      <div className="general-inner-boxes">
        {responseDTOStagesData?.clinicalServiceStageStatus !== 2 ? (
          <>
            <div className="genaral_pds">
              <h2 className="card-heading">General</h2>
            </div>
            <div className="general-info">
              <div className="info-box">
                <span>
                  <CustomLabel name="Name" />
                  <p className="card-inner-value name">
                    {[
                      getValueOrPlaceholder(processedData?.Title),
                      getValueOrPlaceholder(processedData?.FirstName),
                      getValueOrPlaceholder(processedData?.LastName),
                    ]
                      .filter((namePart) => namePart !== "-")
                      .join(" ") || "-"}
                  </p>
                </span>
              </div>
              <div className="info-box">
                <span>
                  <CustomLabel name="Date of birth" />
                  <p className="card-inner-value">
                    {processedData.DOB
                      ? new Date(processedData?.DOB).toLocaleDateString()
                      : "-"}
                  </p>
                </span>
              </div>
            </div>
            <div className="general-info">
              <div className="info-box">
                <span>
                  <CustomLabel name="Email" />
                  <p className="card-inner-value">
                    {getValueOrPlaceholder(processedData?.Email)}
                  </p>
                </span>
              </div>
              <div className="info-box">
                <span>
                  <CustomLabel name="Gender" />
                  <p className="card-inner-value">
                    {getValueOrPlaceholder(processedData?.Gender)}
                  </p>
                </span>
              </div>
            </div>
            <div className="general-info">
              <div className="info-box">
                <span>
                  <div className="d-flex edit-contact">
                    <CustomLabel name="Preferred Contact" />
                  </div>
                  <p className="card-inner-value phone-field">
                    {getValueOrPlaceholder(
                      processedData?.PatientTelephoneNumber
                    )}
                  </p>
                </span>
              </div>
              <div className="info-box">
                <span>
                  <CustomLabel name="Address" />
                  <p className="card-inner-value">
                    {getValueOrPlaceholder(processedData?.PatientAddress)}
                  </p>
                </span>
              </div>
            </div>

            <div className="general-info grids-2">
              <div
                className={`info-box ${
                  serviceName === "Ear Wax" ? "sc-transcript-box" : ""
                }`}
              >
                <span>
                  <CustomLabel
                    name={serviceName === "Ear Wax" ? "Transcript" : "Reason"}
                  />
                  <p className="card-inner-value">
                    {serviceName === "Ear Wax"
                      ? transcript
                      : getValueOrPlaceholder(processedData?.Reason)}
                  </p>
                </span>
              </div>
            </div>
          </>
        ) : (
          <div className="error-msg">
            <p>Patient Details are not available!</p>
          </div>
        )}

        {!serviceName === "Ear Wax" &&
        stage?.clinicalServiceStageStatus === 2 ? (
          <>
            <div className="genaral_pds">
              <h2 className="card-heading">Travel Plans</h2>
            </div>
            {stage?.template?.templateSections.map((section, index) => {
              if (checkCountryExists(section?.sectionTitle)) {
                return (
                  <div key={index}>
                    <PreBookingCountry section={section} />
                  </div>
                );
              }
            })}
            <div className="genaral_pds">
              <h2 className="card-heading">Vaccination History</h2>
            </div>
            {stage?.template?.templateSections.map((section, index) => {
              if (section?.sectionTitle === "Vaccine history") {
                return (
                  <div key={index}>
                    <PreBookingVaccine section={section} />
                  </div>
                );
              }
            })}
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
